/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Digital_Fitness_WellnessInputs */

const en_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness & Wellness`)
};

const es_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness y bienestar`)
};

const fr_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness et Bien-être`)
};

const de_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness & Wellness`)
};

const ja_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィットネス＆ウェルネス`)
};

const zh_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健身与健康`)
};

const ar_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لياقة وصحة`)
};

const id_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebugaran & Kesehatan`)
};

const it_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness & Benessere`)
};

const ru_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фитнес и здоровье`)
};

const pt_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitness e Bem-estar`)
};

const ko_listing_category_digital_fitness_wellness = /** @type {(inputs: Listing_Category_Digital_Fitness_WellnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`피트니스 & 웰니스`)
};

/**
* | output |
* | --- |
* | "Fitness & Wellness" |
*
* @param {Listing_Category_Digital_Fitness_WellnessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_digital_fitness_wellness = /** @type {((inputs?: Listing_Category_Digital_Fitness_WellnessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Digital_Fitness_WellnessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_digital_fitness_wellness(inputs)
	if (locale === "es") return es_listing_category_digital_fitness_wellness(inputs)
	if (locale === "fr") return fr_listing_category_digital_fitness_wellness(inputs)
	if (locale === "de") return de_listing_category_digital_fitness_wellness(inputs)
	if (locale === "ja") return ja_listing_category_digital_fitness_wellness(inputs)
	if (locale === "zh") return zh_listing_category_digital_fitness_wellness(inputs)
	if (locale === "ar") return ar_listing_category_digital_fitness_wellness(inputs)
	if (locale === "id") return id_listing_category_digital_fitness_wellness(inputs)
	if (locale === "it") return it_listing_category_digital_fitness_wellness(inputs)
	if (locale === "ru") return ru_listing_category_digital_fitness_wellness(inputs)
	if (locale === "pt") return pt_listing_category_digital_fitness_wellness(inputs)
	return ko_listing_category_digital_fitness_wellness(inputs)
});